import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";

import {setAIResults, setLookAiImageOpened} from "../../aiActions";


const LookAIImagesOverlayItem = (props) => {

  const {aiResult, aiResults, setAIResults, intl, setLookAiImageOpened} = props;

  const hasResult = aiResult.resultImageUrl;

  const aIResultImageClick = (event) => {
    if (!hasResult || event.target.closest(".look-icon")) {
      return null;
    }
    setAIResults(aiResults.map(aiRes => {
      return Object.assign({}, aiRes, {isActive: aiResult.id === aiRes.id});
    }));
  }

  const aIResultDeleteClick = () => {
    const deletedIndex = aiResults.findIndex(aiRes => aiResult.id === aiRes.id);
    const nextResults = aiResults.length > 3
      ? aiResults.filter(aiRes => aiResult.id !== aiRes.id)
      : aiResults.map(aiRes => {
        if (aiRes.id === aiResult.id) {
          return Object.assign({}, {id: aiResult.id});
        }
        return aiRes;
      });
    let nextActiveIndex = (nextResults[deletedIndex] && nextResults[deletedIndex].resultImageUrl)
      ? deletedIndex
      : nextResults[deletedIndex - 1] && nextResults[deletedIndex - 1].resultImageUrl
        ? deletedIndex - 1
        : nextResults.findIndex(aiRes => aiRes.resultImageUrl) || 0;
    if (!nextResults[nextActiveIndex].resultImageUrl) {
      setLookAiImageOpened(false);
    }
    setAIResults(nextResults.map((aiRes, aiResIndex) => {
      return (aiResIndex === nextActiveIndex) ? Object.assign({}, aiRes, {isActive: true}) : aiRes
    }));
  }

  return (
    <li className={"mb-1 rounded-05 look-ai__images-panel-result bg-light bg-center bg-cover relative"
      + (hasResult ? " cursor-pointer" : "")
      + (aiResult.isActive ? " look-ai__images-panel-result--active" : "")}
        key={aiResult.id}
        style={hasResult ? {backgroundImage: `url(${aiResult.resultImageUrl})`} : null}
        onClick={aIResultImageClick}>
      {hasResult && aiResult.isActive ? (
        <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                    className="look-icon look-icon--small look-icon--white2 absolute right-05 bottom-05"
                    onClick={aIResultDeleteClick}>
          <DeleteIcon/>
        </IconButton>
      ) : null}
    </li>
  )
};

const mapStateToProps = (store) => {
  const {aiResults} = store.aiState;

  return {
    aiResults,
  };
};

const mapDispatchToProps = {
  setAIResults,
  setLookAiImageOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIImagesOverlayItem)
)
